"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRESENCE_STATUS = void 0;
var PRESENCE_STATUS = exports.PRESENCE_STATUS = {
  ONLINE: 0,
  BUSY: 1,
  AWAY: 2,
  DISCONNECTED: 3
};